import axios from "axios";

export default {
	async sendMessage(payload) {
		return await axios.post("/send_message", payload);
	},

};
